import { SuccessButton } from '@components/Buttons/SuccessButton';
import { FilterBar } from '@components/FilterBar';
import { GridItem } from '@components/GridItem';
import { useModalWindow } from '@hooks/useModalWindow';
import { Button } from '@material-ui/core';
import { ICliente } from '@model/Cliente';
import { IClienteSaldo } from '@model/ClienteSaldo';
import { IComboEmpresa } from '@model/Empresa';
import { EnumTipoSaldo } from '@services/ClienteService';
import { AxiosResponse } from 'axios';
import React from 'react';
import { SaldoRegistrarModal } from './SaldoRegistrarModal';

export type SaldoFilterProps = {
    cliente: ICliente
    empresaCombo: IComboEmpresa
    isLoading: boolean
    onSaldoRegistrado: (response: AxiosResponse<IClienteSaldo>) => void
}

export function SaldoFilter ({ empresaCombo, cliente, onSaldoRegistrado }: SaldoFilterProps) {
    const [tipoSaldo, setTipoSaldo] = React.useState<EnumTipoSaldo>();

    const registrarSaldoModal = useModalWindow();

    const handleCreditoClick = React.useCallback(() => {
        setTipoSaldo(EnumTipoSaldo.Credito);
        registrarSaldoModal.open();
    }, [registrarSaldoModal]);

    const handleDebitoClick = React.useCallback(() => {
        setTipoSaldo(EnumTipoSaldo.Debito);
        registrarSaldoModal.open();
    }, [registrarSaldoModal]);

    return (
        <React.Fragment>
            <FilterBar>
                <GridItem>
                    <SuccessButton onClick={handleCreditoClick}>Novo Crédito</SuccessButton>
                </GridItem>
                <GridItem>
                    <Button variant="contained" onClick={handleDebitoClick} color="secondary">Novo Débito</Button>
                </GridItem>
            </FilterBar>

            {
                tipoSaldo !== undefined && (
                    <SaldoRegistrarModal 
                        modal={registrarSaldoModal}
                        empresaCombo={empresaCombo}
                        cliente={cliente}
                        onSaldoRegistrado={onSaldoRegistrado}
                        tipoSaldo={tipoSaldo}
                    />
                )
            }
        </React.Fragment>
    )
}